const baseUrl = import.meta.env.VITE_API_URL;
const isProduction = import.meta.env.MODE === 'production';
const sentryDsn = import.meta.env.VITE_SENTRY_DSN;

const companyName = /:\/\/([^/]+)/.exec(window.location.href)?.[1] ?? 'Your';

const invalidationTags = {
  brandingTag: 'Branding',
  companyTag: 'Company',
  deviceTag: 'Device',
  eventTag: 'Event',
  gameDictionaryTag: 'GameDictionary',
  gameTag: 'Game',
  meTag: 'Me',
  syncTag: 'Sync',
  userTag: 'User',
};

export { baseUrl, companyName, invalidationTags, isProduction, sentryDsn };
